import React from 'react';
import { StackScreen } from '@banhala/ui-kit';
import { WebView } from 'shared/src/component/WebWebView';
import { useWebBaseURL } from 'shared/src/hooks';
import { isNotNil } from 'shared/src/utils';

export const MyPageScreen = () => {
  const webBaseUrl = useWebBaseURL();

  return (
    <StackScreen title={'마이페이지'} hideBackButton={true}>
      {isNotNil(webBaseUrl) && (
        <WebView
          source={{ uri: `${webBaseUrl}/mypage/me?global_layout=app` }}
        />
      )}
    </StackScreen>
  );
};
